import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { getBackgroundImageStyles } from "src/app/shared/functions/ng-style-utils";
import type { Swiper } from "swiper";
import { map } from 'rxjs/operators';
@Component({
    selector: "app-landing-page-header",
    templateUrl: "./landing-page-header.component.html",
    styleUrls: ["./landing-page-header.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LandingPageHeaderComponent implements OnInit {
  swiper: Swiper;
  headers: Observable<any>;
  constructor(private _api: ApiService) {
    this.headers = this._api
      .getDrupalLandingPageHeaders()
      .pipe(map((headers: any[]) => {
        headers.forEach((h) => (h.bgStyle = this.getBackground(h.image)));
        return headers;
      }));
  }

  ngOnInit(): void {
    console.log(this.swiper);
  }

  onSwiper(swiper: Swiper) {
    this.swiper = swiper;
  }
  getBackground(img) {
    return getBackgroundImageStyles(0.4, img);
  }
  searchFocused() {
    this.swiper?.autoplay?.stop();
  }
}
